import api from './api';

/**
 * Booking Service
 * Handles all booking-related API calls
 */

const bookingService = {
  /**
   * Get astrologer's available slots for tomorrow
   * @param {number} astrologerId - ID of the astrologer
   * @returns {Promise} Available slots data
   */
  getAvailableSlots: (astrologerId) => {
    return api.get(`/astrologers/${astrologerId}/availability/tomorrow`);
  },

  /**
   * Book a consultation slot
   * @param {number} slotId - ID of the slot to book
   * @param {string} userNotes - Optional notes from user
   * @returns {Promise} Booking confirmation data
   */
  createBooking: (slotId, userNotes = '') => {
    return api.post('/bookings', {
      slot_id: slotId,
      user_notes: userNotes
    });
  },

  /**
   * Get user's booking history
   * @param {Object} filters - Query filters (status, limit, offset)
   * @returns {Promise} List of bookings
   */
  getUserBookings: (filters = {}) => {
    return api.get('/bookings', { params: filters });
  },

  /**
   * Get specific booking details
   * @param {number} bookingId - ID of the booking
   * @returns {Promise} Booking details
   */
  getBooking: (bookingId) => {
    return api.get(`/bookings/${bookingId}`);
  },

  /**
   * Cancel a booking
   * @param {number} bookingId - ID of the booking to cancel
   * @returns {Promise} Cancellation confirmation
   */
  cancelBooking: (bookingId) => {
    return api.delete(`/bookings/${bookingId}`);
  }
};

export default bookingService;
